exports.getRating = params => {
    const { submission } = params;

    return apigClient
        .apiGetRatingPost({}, JSON.stringify(submission), {})
        .then(resp => {
            return resp;
        })
        .catch(error => {
            return Promise.reject({
                _error: error.message
            });
        });
};
const sortGroups = (exports.sortGroups = (ratings, type) => {
    return Object.keys(ratings).sort((a, b) => {
        if (a === type) {
            return -1;
        } else {
            if (b === 'options') {
                return -1;
            } else {
                return 1;
            }
        }
    });
});

exports.groupRatings = (ratings, type) => {
    const struct = { offers: [], upsell: [], options: [] };
    return sortGroups(ratings, type).reduce((prev, curr, idx) => {
        const keys = Object.keys(struct);
        const pointer = keys[idx];
        const rating = ratings[curr];
        rating.type = curr;

        if (curr === type) {
            prev.offers.push(rating);
        } else {
            prev[pointer].push(rating);
        }

        return prev;
    }, struct);
};

export default exports.getRating;
